import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { getFirestore, doc, setDoc, collection, getDocs } from "firebase/firestore";
import { app } from "../firebase";
import { useToast } from "../components/ToastProvider";

const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 16px;
  padding: 2rem;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
`;

const Title = styled.h3`
  margin-bottom: 1.5rem;
  text-align: center;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
  gap: 1rem;
`;

const Button = styled.button`
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  border: none;
  background: ${(props) => (props.cancel ? "#777" : "#3a79ed")};
  color: white;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: ${(props) => (props.cancel ? "#555" : "#235279")};
  }
`;

const SwitchWrapper = styled.label`
  position: relative;
  display: inline-block;
  width: 46px;
  height: 26px;
`;

const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

const SwitchSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 26px;

  ${SwitchInput}:checked + & {
    background-color: #4caf50;
  }

  &::before {
    content: "";
    position: absolute;
    height: 20px; width: 20px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    border-radius: 50%;
    transition: 0.4s;
  }

  ${SwitchInput}:checked + &::before {
    transform: translateX(20px);
  }
`;

const SelectHorario = styled.select`
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 1rem;
  background: white;
  color: #1F1A40;
  width: 100%;
  max-width: 150px;

  &:focus {
    outline: none;
    border-color: #555;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 0.5rem 0;
  }
`;

const diasDaSemana = ["domingo", "segunda", "terca", "quarta", "quinta", "sexta", "sabado"];

export default function ModalHorarioFuncionamento({ isOpen, onClose, form, setForm, barbeiroId, barbeariaId }) {
    const db = getFirestore(app);
    const [loading, setLoading] = useState(false);
    const [horarioFuncionamentoBarbearia, setHorarioFuncionamentoBarbearia] = useState({
        inicio: "00:00",
        fim: "23:45"
    });
    const { show, success, error } = useToast();

    useEffect(() => {
        const carregarHorarios = async () => {
            if (!barbeariaId || !barbeiroId) return;

            const barbeiroRef = collection(db, `barbearia/${barbeariaId}/barbeiros/${barbeiroId}/horarioFuncionamento`);
            const barbeiroSnap = await getDocs(barbeiroRef);

            const diasPadrao = ["domingo", "segunda", "terca", "quarta", "quinta", "sexta", "sabado"];
            const dados = {};
            let menorInicio = "23:59";
            let maiorFim = "00:00";

            if (!barbeiroSnap.empty) {
                // ✅ Usa horários do barbeiro
                barbeiroSnap.forEach(doc => {
                    const dia = doc.id;
                    const { aberto = false, horarioInicio = "", horarioTermino = "" } = doc.data();
                    dados[dia] = { aberto, horarioInicio, horarioTermino };

                    if (aberto && horarioInicio && horarioTermino) {
                        if (horarioInicio < menorInicio) menorInicio = horarioInicio;
                        if (horarioTermino > maiorFim) maiorFim = horarioTermino;
                    }
                });
            } else {
                console.log("teste")
                // ❌ Não tem horário do barbeiro → usa da barbearia
                const barbeariaRef = collection(db, `barbearia/${barbeariaId}/horarioFuncionamento`);
                const barbeariaSnap = await getDocs(barbeariaRef);


                barbeariaSnap.forEach(doc => {
                    console.log("Horário barbearia:", doc.id, doc.data());
                    const dia = doc.id;
                    const { aberto, horarioInicio, horarioTermino } = doc.data();
                    dados[dia] = { aberto, horarioInicio, horarioTermino };

                    if (aberto && horarioInicio && horarioTermino) {
                        if (horarioInicio < menorInicio) menorInicio = horarioInicio;
                        if (horarioTermino > maiorFim) maiorFim = horarioTermino;
                    }
                });
            }

            // ⚠️ Garante que todos os dias existam no objeto final
            diasPadrao.forEach((dia) => {
                if (!dados[dia]) {
                    dados[dia] = { aberto: false, horarioInicio: "", horarioTermino: "" };
                }
            });

            setForm((prev) => ({
                ...prev,
                horarios: dados,
            }));

            setHorarioFuncionamentoBarbearia({ inicio: menorInicio, fim: maiorFim });
        };

        carregarHorarios();
    }, [barbeariaId, barbeiroId]);

    if (!isOpen) return null;

    const gerarHorarios = () => {
        const horarios = [];
        for (let h = 0; h < 24; h++) {
            for (let m = 0; m < 60; m += 15) {
                const hora = String(h).padStart(2, "0");
                const minuto = String(m).padStart(2, "0");
                horarios.push(`${hora}:${minuto}`);
            }
        }
        return horarios;
    };

    function gerarHorariosFiltrados() {
        const horarios = [];
        const [limiteInicioH, limiteInicioM] = horarioFuncionamentoBarbearia.inicio.split(":").map(Number);
        const [limiteFimH, limiteFimM] = horarioFuncionamentoBarbearia.fim.split(":").map(Number);

        const inicioMinutos = limiteInicioH * 60 + limiteInicioM;
        const fimMinutos = limiteFimH * 60 + limiteFimM;

        for (let min = 0; min < 24 * 60; min += 15) {
            if (min < inicioMinutos || min > fimMinutos) continue;
            const h = String(Math.floor(min / 60)).padStart(2, "0");
            const m = String(min % 60).padStart(2, "0");
            horarios.push(`${h}:${m}`);
        }

        return horarios;
    }


    const atualizarDia = (dia, campo, valor) => {
        setForm((prev) => ({
            ...prev,
            horarios: {
                ...prev.horarios,
                [dia]: {
                    ...prev.horarios[dia],
                    [campo]: valor,
                },
            },
        }));
    };

    const toggleDia = (dia, aberto) => {
        setForm((prev) => ({
            ...prev,
            horarios: {
                ...prev.horarios,
                [dia]: {
                    aberto,
                    horarioInicio: aberto ? "09:00" : "",
                    horarioTermino: aberto ? "18:00" : "",
                },
            },
        }));
    };

    const salvarHorarios = async () => {
        if (!barbeiroId || !barbeariaId) return;
        setLoading(true);
        const horarios = form.horarios;

        for (const dia in horarios) {
            const ref = doc(db, `barbearia/${barbeariaId}/barbeiros/${barbeiroId}/horarioFuncionamento/${dia}`);
            await setDoc(ref, horarios[dia]);
        }

        setLoading(false);
        success("Horários salvos com sucesso!");
        onClose();
    };
    

    return (
        <Overlay>
            <ModalContent>
                <Title>Horário de Trabalho do Barbeiro</Title>

                {diasDaSemana.map((dia) => {
                    const diaData = form.horarios?.[dia] || {};
                    return (
                        <div key={dia} style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "1rem",
                            borderBottom: "1px solid #ddd",
                            paddingBottom: "0.5rem"
                        }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                                <SwitchWrapper>
                                    <SwitchInput
                                        type="checkbox"
                                        checked={diaData.aberto}
                                        onChange={(e) => toggleDia(dia, e.target.checked)}
                                    />
                                    <SwitchSlider />
                                </SwitchWrapper>
                                <strong style={{ textTransform: "capitalize" }}>{dia}</strong>
                            </div>
                            {diaData.aberto ? (
                                <div style={{ display: "flex", gap: "0.5rem" }}>
                                    <SelectHorario
                                        value={diaData.horarioInicio}
                                        onChange={(e) => atualizarDia(dia, "horarioInicio", e.target.value)}
                                    >
                                        <option value="" hidden>Início</option>
                                        {gerarHorariosFiltrados().map(h => <option key={h} value={h}>{h}</option>)}
                                    </SelectHorario>
                                    <SelectHorario
                                        value={diaData.horarioTermino}
                                        onChange={(e) => atualizarDia(dia, "horarioTermino", e.target.value)}
                                    >
                                        <option value="" hidden>Fim</option>
                                        {gerarHorariosFiltrados().map(h => <option key={h} value={h}>{h}</option>)}
                                    </SelectHorario>
                                </div>
                            ) : (
                                <div style={{ fontWeight: "500", color: "#888" }}>Fechado</div>
                            )}
                        </div>
                    );
                })}

                <Footer>
                    <Button cancel onClick={onClose}>Cancelar</Button>
                    <Button onClick={salvarHorarios} disabled={loading}>
                        {loading ? "Salvando..." : "Salvar"}
                    </Button>
                </Footer>
            </ModalContent>
        </Overlay>
    );
}
